import React from 'react'
import { ElementProps } from '../base/element'
import { ICommonProps, IDefaultStyles } from '../schemamanager/types'

export interface IDividerComponent extends ICommonProps {
    type: 'divider'

}

const style: IDefaultStyles = {
  main: {
    classes: {
      margin: 'mx-2 my-1'
    }
  }
}


export const Divider = (props: ElementProps) => {
  const m = props.mergeStyles(style)

  return (
    <hr {...m.main} {...props.events()}/>
  )
}
